<template>
  <RACQFormKit
    v-model="isOverseasSelected"
    :name="`postalOverseas-${instanceIdentifier}`"
    :bindings="
      {
        label: overseasOptionLabel,
        name: `postalOverseas-${instanceIdentifier}`,
        type: 'toggle',
        options: [
          { label: 'Australia', value: 'false' },
          { label: 'Overseas', value: 'true' },
        ],
        defaultOption: 'false',
        tooltip: {
          content: overseasOptionTooltip,
          tooltipId: 'overseas_option__tooltip_id',
          tooltipOuterId: 'overseas_option__outer',
          isModal: false,
        },
      } as VueFormInputProps
    "
  >
  </RACQFormKit>
</template>
<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import { useMultiInstanceAddressOptionsStore, emitAddressReset, addressLookupEmits } from '@/store';
import { VueFormInputProps } from '@/composables/useFormInputData';
import RACQFormKit from '../RACQFormKit/RACQFormKit.vue';
import { toBool } from '@/utils/convert';
import { AUSTRALIA } from '@/constants/general-words.const';

const emit = defineEmits(addressLookupEmits);

const props = defineProps<{
  defaultIsOverseasOption?: boolean;
  instanceIdentifier: string;
  overseasOptionLabel: string;
  overseasOptionTooltip: string;
}>();

const multiInstanceAddressStore = useMultiInstanceAddressOptionsStore();
const addressLookupOptionsStore = multiInstanceAddressStore.getInstance(props.instanceIdentifier);

const isOverseasSelected = ref<string>('false');

onMounted(async () => {
  const isOverseas = addressLookupOptionsStore.isOverseasManualAddress();
  isOverseasSelected.value = isOverseas?.toString();
});

watch(
  () => isOverseasSelected.value,
  async (newValue, oldValue) => {
    if (oldValue) {
      const enableManualEntry = oldValue !== undefined;
      addressLookupOptionsStore.onIsOverseasChanged(toBool(newValue), enableManualEntry);

      if (!toBool(newValue)) {
        addressLookupOptionsStore.manualAddressComponents.country = AUSTRALIA;
      }

      emit(emitAddressReset);
    } else {
      addressLookupOptionsStore.isOverseasSelection = toBool(newValue);
    }
  }
);

watch(
  () => addressLookupOptionsStore.isOverseasSelection,
  async (newValue) => {
    isOverseasSelected.value = newValue.toString();
  }
);
</script>
